module.exports = __webpack_public_path__ + "static/assets/40998229311219c2117265d5e4bd9745.png";